import '../otraco-obp-shared/index.css';

function setPlaceholder(root, selector, text) {
	const field = root.querySelector(selector);
	if (!field || text === '') {
		return;
	}

	field.setAttribute('placeholder', text);
}

function initContactBanner(root) {
	const subjectInput = root.querySelector('input[name="your-subject"]');
	if (!subjectInput || subjectInput.value.trim() !== '') {
		// Continue applying placeholder and button parity updates.
	} else {
		subjectInput.value = 'Otraco OBP inquiry';
	}

	setPlaceholder(root, 'input[name="your-name"]', 'Full Name');
	setPlaceholder(root, 'input[name="your-email"]', 'Email');
	setPlaceholder(root, 'textarea[name="your-message"]', 'Tell us about your project');

	const submitInput = root.querySelector('input[type="submit"]');
	if (submitInput) {
		submitInput.value = 'Get in touch';
	}

	const submitButton = root.querySelector('button[type="submit"]');
	if (submitButton && submitButton.textContent) {
		submitButton.textContent = 'Get in touch';
	}
}

function initContactBanners() {
	const blocks = document.querySelectorAll('[data-otraco-obp-contact-banner]');
	blocks.forEach((block) => initContactBanner(block));
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initContactBanners);
} else {
	initContactBanners();
}
